import classNames from './MoveStudentsPopup.module.scss';
import { useAdminTranslation } from '@/admin/hooks/useAdminTranslation';
import { StudentReportItem } from '@/school-management/types/response';
import {
  MoveClassDestination,
  BulkOperationResponseData,
  BulkOperationState,
} from '@/school-management/types/services/bulk';
import Button from '@/components/school-management/Button/Button';
import Download from './Download';

interface SuccessesProps {
  students: StudentReportItem[];
  classDestination: MoveClassDestination;
  moveSource: 'ChooseDestination' | 'DifferentGradeAll' | 'DifferentGradeSame';
  bulkOperation?: BulkOperationResponseData;
  onClose: () => void;
}

const Successes = ({
  students,
  classDestination,
  moveSource,
  bulkOperation,
  onClose,
}: SuccessesProps) => {
  const { t } = useAdminTranslation();

  return (
    <>
      <div>
        <div className={classNames.title} style={{ maxWidth: '455px' }}>
          {t('bulkActions.moveStudents.successes.title')}
        </div>
        <div className={classNames.description} style={{ maxWidth: '355px' }}>
          {t('bulkActions.moveStudents.successes.description')}
        </div>
      </div>
      <Download
        students={students}
        classDestination={classDestination}
        moveSource={moveSource}
        bulkOperation={bulkOperation}
        bulkOperationState={BulkOperationState.Completed}
      />
      <div className={classNames.footer}>
        <Button className={classNames.button} onClick={onClose}>
          {t('done')}
        </Button>
      </div>
    </>
  );
};

export default Successes;
